import { Divider, Stack } from 'braid-design-system';
import { type ComponentProps, useState } from 'react';
import { LocationSelectMap, BreadCrumbsString } from 'wingman-fe';

import { CopyableText } from '#src/components/CopyableText/CopyableText.tsx';
import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { SectionHeadingLink } from './SectionHeadingLink/SectionHeadingLink.tsx';
import { flattenResourceByKey } from './flattenResourceByKey.ts';

type Location = Parameters<
  ComponentProps<typeof LocationSelectMap>['onLocationSelected']
>[0];

const SEEK_MEL_CENTER: [number, number] = [-37.8275, 144.9902];

export const LocationSelectMapSection = () => {
  const { seekAnzSchemeId } = useEnvironmentConfig();
  const [location, setLocation] = useState<Location | undefined>();
  return (
    <Stack space="large">
      <SectionHeadingLink href="/use-cases/job-posting/locations#nearestlocations">
        Nearest locations
      </SectionHeadingLink>
      <Stack space="small">
        <LocationSelectMap
          schemeId={seekAnzSchemeId}
          onLocationSelected={setLocation}
          initialLocation={SEEK_MEL_CENTER}
        />
        {location ? (
          <Stack space="large">
            <BreadCrumbsString
              segments={flattenResourceByKey(location, 'parent').map((x) => ({
                name: x.name,
                key: x.id.value,
              }))}
            />
            <Divider />
            <CopyableText inlineCode>{location.id.value}</CopyableText>
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
};
